import moment from "moment";
import { formatMoney } from "../../../features/utils/formatMoney";
import { getSupplierName } from "../../flight/supplier/getSupplierName";
import { getSupplierClass } from "../../../components/flight/FlightOfferDisplay";
import { flightStatusMap } from "../../../pages/Orders/OrdersData";
import Icon from "../../../components/HOC/Icon";

export function templatePackageOrderData(data) {
  const packageData = data;
  // debugger
  let flightType = "One Way";
  console.log({ packageData });
  if (packageData?.destinations?.length) {
    flightType = "Multi City";
    if (
      packageData?.destinations?.at(-1)?.to ===
      packageData?.destinations?.at(0)?.from
    )
      flightType = "Return";
  }
  let travellers =
    packageData?.requestBody?.reservationDetails?.map((person) => {
      return {
        type: "text",
        value: person?.firstName + " " + person?.lastName,
      };
    }) || [];

  return [
    {
      elements: [
        {
          type: "title",
          value: moment(data?.createdAt)?.format("DD-MM-YYYY HH:mm [GMT]Z"),
        },
        {
          type: "copy",
          value: packageData?.bookingId,
          renderValue: () => packageData?.bookingId,
        },
        // {
        //   type: "tag",
        //   value: getSupplierName(packageData?.supplier),
        //   className: getSupplierClass(packageData?.supplier),
        //   color: "text-[#BD002A]",
        //   background: "bg-[#BD002A]/20",
        // },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[25%]",
    },
    // {
    //   elements: [
    //     {
    //       type: "title",
    //       value: "Type",
    //     },
    //     {
    //       type: "text",
    //       value: packageData?.orderData?.orderData?.requestBody?.policyType,
    //     },
    //   ],
    //   width: "md:w-[15%]",
    // },
    {
      elements: [
        { type: "title", value: "Startt Date" },
        {
          type: "text",
          value: moment(packageData?.startDate)?.format("DD MMM"),
        },
      ],
      value: moment(packageData?.travelDate)?.format("YYYY-MM-DD"),
      width: "md:w-[15%]",
    },
    {
      elements: [{ type: "title", value: "Travellers" }, ...travellers],
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Agent Price" },
        {
          type: "text",
          value: formatMoney(
            packageData?.fareTotal ||
              packageData?.grandTotal ||
              packageData?.amount,
          ),
        },
      ],
      value: packageData?.payable,
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Status" },
        { type: "status", value: packageData?.status },
        {
          type: "time",
          render: () => {
            const diffInSeconds = moment
              .utc(packageData?.ticketingExpiry)
              .diff(moment.utc(), "seconds");

            // Format the difference in the "5h 10m 5s" format
            const hours = Math.floor(diffInSeconds / 3600);
            const minutes = Math.floor((diffInSeconds % 3600) / 60);
            // const seconds = diffInSeconds % 60;
            const onStage = ["Paid", "Pending", "Pendingpayment"]?.includes(
              packageData?.status,
            );

            return (hours || minutes) > 0 && onStage ? (
              <div
                className="flex gap-1 items-center"
                title="Ticket Expiry Time"
              >
                <Icon icon="mdi:clock-outline" className="!w-4 !h-4" />
                {hours || minutes} {hours ? "Hrs" : "Mins"}
              </div>
            ) : null;
          },
        },
      ],
      value: (function () {
        return [
          "Not Paid",
          "Paid",
          "Expired",
          "Awaiting ticketing",
          "Ticket issued",
          "Denied",
          "Canceled",
          "Cancelation Requested",
          "Ticket Canceled",
        ]?.findIndex((val) => val === flightStatusMap(packageData?.status));
      })(),
      width: "md:w-[15%]",
    },
  ];
}
